import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';
import { createContextId } from '@builder.io/qwik';

export const ArticleContext = createContextId<
  Partial<ArticleInterface> | undefined
>('article');
